export const heroStatement = ['Not a style, a perspective.', 'Brands built to be felt.'];

export const heroStats = ['AI-first Branding & Creative Agency'];

/** Shown in the right-hand slot of the hero's bottom row */
export const heroSocials = [
  { label: 'Instagram', href: 'https://instagram.com' },
  { label: 'LinkedIn', href: 'https://linkedin.com' },
  { label: 'X.com', href: 'https://x.com' },
];
